import React, { useState, useEffect } from 'react';

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(
    !localStorage.getItem('installPromptRejected')
  );

  useEffect(() => {
    if (!showInstallPrompt) return;

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, [showInstallPrompt]);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
        } else {
          console.log('User dismissed the install prompt');
        }
        setDeferredPrompt(null);
        setShowInstallPrompt(false);
      });
    }
  };

  const handleCloseClick = () => {
    setShowInstallPrompt(false);
    localStorage.setItem('installPromptRejected', 'true');
  };

  if (!showInstallPrompt) {
    return null;
  }

  return (
    <div
      className="position-fixed top-0  m-3 p-3 bg-light rounded shadow d-flex align-items-center"
      style={{ zIndex: 2000 }}
    >
      <p className="me-2 mb-0">Install for a better experience!</p>
      <button className="btn btn-primary me-2" onClick={handleInstallClick}>
        Install
      </button>
      <button className="btn btn-secondary" onClick={handleCloseClick}>
        I'll do it later
      </button>
    </div>
  );
};

export default InstallPrompt;